var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-container strategy-cluster" }, [
    _c("div", { staticClass: "flex-row flex-1" }, [
      _c("div", { staticClass: "flex-col flex-1 rotate" }, [
        _c("div", { staticClass: "flex-row rotate-content textnowrap" }, [
          _vm._v(" " + _vm._s(_vm.$t("uniperStrategyCluster")) + " "),
        ]),
      ]),
      _c("div", { staticClass: "flex-col flex-1 rotate" }, [
        _c(
          "div",
          { staticClass: "flex-row rotate-content blueFont textnowrap" },
          [_vm._v(" " + _vm._s(_vm.isInTargetText) + " ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }